const arrayMoveMutate = (array, from, to) => {
  const startIndex = to < 0 ? array.length + to : to;
  const item = array.splice(from, 1)[0];
  array.splice(startIndex, 0, item);
};

export default function (array, from, to) {
  // eslint-disable-next-line no-param-reassign
  array = array.slice();
  arrayMoveMutate(array, from, to);
  return array;
}



// WEBPACK FOOTER //
// ./src/app/common/utils/ArrayMove.js